
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M11.908 7.5c.486 0 .778.56.463.953L7.688 14.28c-.344.424-1.052.195-1.052-.368V8.5H4.092c-.486 0-.78-.562-.463-.953L8.31 1.721c.344-.427 1.055-.197 1.055.366V7.5h2.543zm-2.952 1a.59.59 0 01-.591-.587V3.25L4.95 7.5h2.094a.59.59 0 01.592.587v4.663L11.05 8.5H8.956z"}})])
          )
        }
      }
    